import $ from 'jquery';

function AnchorTag(element) {
  this.$element = $(element);
  this.init();
}

AnchorTag.prototype = {
  init() {
    this.$element.on('click', (event) => {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: $(this.$element.attr('href')).offset().top - 90,
      }, 500);
    });
  },
};

export default AnchorTag;
